/**
 * @readonly
 * @enum {string}
 */
export default Object.freeze({
  BookingCashRefund: 'BookingCashRefund',
  BookingAddPayment: 'BookingAddPayment',
  BookingPushInvoice: 'BookingPushInvoice',
  BookingRegisterPayment: 'BookingRegisterPayment',
  BookingCheckin: 'BookingCheckin',
  BookingShowOnPlanboard: 'BookingShownOnPlanboard',
  BookingAddVoucher: 'BookingAddVoucher',
  BookingAddDiscount: 'BookingAddDiscount',
  BookingNoShow: 'BookingNoShow',
  BookingEditSchedule: 'BookingEditSchedule',
  BookingEdit: 'BookingEdit',
  BookingChangeCustomer: 'BookingChangeCustomer',
  BookingAddCustomer: 'BookingAddCustomer',
  BookingEditVisitors: 'BookingEditVisitors',
  BookingEditNotes: 'BookingEditNotes',
  CustomerEdit: 'CustomerEdit',
  NewPlanboard: 'NewPlanboard'
})

/*
12/10/2021 Complete list from Remco:
Please only use those that are necesary

public enum FeatureFlags
{
  None,
  ResourceGroup,
  PlanboardSlideIn,
  PlanboardToggleSlotTypes,
  PlanboardUpNext,
  PlanboardBlockCapacity,
  BookingRegisterPayment,
  BookingAddPayment,
  BookingCheckin,
  BookingShownOnPlanboard,
  BookingAddVoucher,
  BookingCashRefund,
  BookingNoShow,
  BookingEditSchedule,
  BookingEdit,
  BookingAddDiscount,
  BookingChangeCustomer,
  BookingAddContact,
  BookingEditVisitors,
  BookingEditNotes,
  BookingPushInvoice,
  ScheduleAvailable,
  CustomerEdit,
  ProductDurationPerParticipant,
  ReportWorklist,
  ReportDailyReport,
  ReportOperationsList,
  ReportExports,
  ReportAccounting,
  AllowMoreThanTwoSegments,
  EnableVanityDomains,
}
*/
